export default __webpack_public_path__ + "static/media/20-2.2bc6ef88.mp3";